export default __webpack_public_path__ + "static/symptomsearch-d0c770b46c8591471f7b0e1cfb79f143.mp4";